import { render } from "./HallofFameView.vue?vue&type=template&id=5b0216c4&scoped=true"
import script from "./HallofFameView.vue?vue&type=script&lang=js"
export * from "./HallofFameView.vue?vue&type=script&lang=js"

import "./HallofFameView.vue?vue&type=style&index=0&id=5b0216c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0216c4"]])

export default __exports__